import { sessionManager } from "@/services/sessionManager";
import { AUTH_ACTION_TYPES } from "./actionTypes";
const EMPTY_SESSION_DATA = {
    customerIdentifier: null,
    customerAWSAccountID: null,
    productCode: null,
    sub: null,
    email: null,
    role: null,
    tokenExpiry: null
};
function resolveProductCode(sessionUser) {
    if (sessionUser.products && sessionUser.products.length > 0) {
        return sessionUser.products[0].productCode;
    }
    return sessionUser.productCode;
}
function toStoreSessionData(sessionUser) {
    return {
        customerIdentifier: sessionUser.customerIdentifier,
        customerAWSAccountID: sessionUser.customerAWSAccountID,
        productCode: resolveProductCode(sessionUser),
        sub: sessionUser.sub,
        email: sessionUser.email,
        role: sessionUser.role,
        tokenExpiry: sessionUser.exp
    };
}
export function createAuthUser(email, sub) {
    return {
        id: sub || "unknown",
        email,
        firstName: "User",
        lastName: "Name",
        isAdmin: false
    };
}
export function clearStoredSessionData(setSessionData) {
    setSessionData(EMPTY_SESSION_DATA);
}
export function processSessionAndDispatch({ sessionData, setSessionData, dispatch, mfaSetupRequired = false, fallbackEmail }) {
    if (sessionData.success && sessionData.user) {
        const user = createAuthUser(sessionData.user.email, sessionData.user.sub);
        setSessionData(toStoreSessionData(sessionData.user));
        if (sessionData.user.exp) {
            sessionManager.setTokenExpiry(sessionData.user.exp);
        }
        dispatch({
            type: AUTH_ACTION_TYPES.AUTH_SUCCESS,
            payload: {
                user,
                mfaSetupRequired
            }
        });
        return true;
    }
    if (fallbackEmail) {
        dispatch({
            type: AUTH_ACTION_TYPES.AUTH_SUCCESS,
            payload: {
                user: createAuthUser(fallbackEmail),
                mfaSetupRequired
            }
        });
    }
    return false;
}
